<template>
    <div class="animated fadeIn">
        <b-card header-tag="header">
            <div slot="header">
                <i class="fa fa-money"></i> Remessa de Pagamentos
                <b-link :to="actionUri" class="btn mr-2 btn-sm btn-primary float-right">
                <i class="fa fa-angle-left"></i>
                  Voltar
                </b-link>
            </div>
            <b-card-body>
                <form class="needs-validation" novalidate>
                    <div class="form-row justify-content-start">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Nome</label>
                                <div class="form-control-plaintext"><strong>{{model.name}}</strong></div>                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Valor</label>
                                <input disabled type="text" v-model="amount" class="form-control-plaintext" style="font-weight:bold;" />                                
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label>Banco</label>
                                <div class="form-control-plaintext"><strong>{{bankName}}</strong></div>                                
                            </div>
                        </div>                        
                        <div class="col-sm-12 col-md-3" v-if="model.status == 'CREATED' || model.status == 'PROCESSING'">
                            <div class="form-group">
                                <label>&nbsp;</label>
                                <b-input-group>
                                    <b-input-group-append>
                                        <b-dropdown id="dropdown-1" text="Ações" variant="primary">
                                            <b-dropdown-item v-if="canFinalizeMoneyOutGroup" @click="finalizeMoneyOutGroup">Finalizar Remessa</b-dropdown-item>
                                            <b-dropdown-item @click="cancelMoneyOutGroup">Cancelar Remessa</b-dropdown-item>                            
                                        </b-dropdown>                                          
                                    </b-input-group-append>
                                </b-input-group>                                                        
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div class="form-row justify-content-start">
                        <div class="col-sm-1 col-md-3">
                            <div class="form-group">
                                <label>Criado em</label>
                                <input disabled type="text" v-model="createdAt" class="form-control-plaintext" style="font-weight:bold;" />                                
                            </div>
                        </div>
                        <div class="col-sm-1 col-md-3">
                            <div class="form-group">
                                <label>Atualizado em</label>
                                <input disabled type="text" v-model="updatedAt" class="form-control-plaintext" style="font-weight:bold;" />                                
                            </div>
                        </div>
                        <div class="col-sm-1 col-md-3">
                            <div class="form-group">
                                <label>Status</label>
                                <div class="form-control-plaintext"><strong>{{status}}</strong></div>                                
                            </div>
                        </div>                        
                    </div>
                </form>
            </b-card-body>
        </b-card>
        <b-card>
            <div slot="header">
                Arquivos                
            </div>
            <b-card-body>
                <div class="form-row float-right mb-3 justify-content-start" v-if="model.status == 'CREATED' || model.status == 'PROCESSING'">
                    <div class="col-sm-2">
                        <b-dropdown id="dropdown-1" text="Ações" variant="primary">
                            <b-dropdown-item @click="createNewFile">Novo arquivo remessa</b-dropdown-item>
                            <b-dropdown-item @click="uploadModal">Upload arquivo retorno</b-dropdown-item>                            
                        </b-dropdown>                        
                    </div>
                </div>
                <c-table :table-data="filesData" :fields="filesDataFields" :customActions="customActions" @onCustomActionClick="onCustomActionClick" striped></c-table>
            </b-card-body>
        </b-card>
        <b-card>
            <div slot="header">
                Pagamentos                
            </div>
            
            <b-card-body>
                <b-row class="float-right mb-3 justify-content-start">
                    <b-col md="6" class="my-1">
                    <b-form-group label-cols-sm="0" label class="mb-0">
                        <b-input-group>
                            <b-input-group-append>
                                <b-dropdown id="dropdown-1" text="Ações" variant="primary" >
                                    <b-dropdown-item @click="exportItemsData">Exportar</b-dropdown-item>                            
                                </b-dropdown>                                          
                            </b-input-group-append>
                        </b-input-group>           
                    </b-form-group>
                    </b-col>
                </b-row>
                <b-table
                    :items="result.data"
                    :fields="fields"
                    :striped="true"
                    responsive                
                >
                    <template slot="amount" slot-scope="data">{{formatDecimalFields(data.value)}}</template>
                    <template slot="status" slot-scope="data">{{bindStatusName(data.value)}}</template>
                    <template slot="customerType" slot-scope="data">{{bindBusinessTypeName(data.value)}}</template>
                    <template slot="scheduledDate" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>
                    <template slot="endedAt" slot-scope="data">{{formatDateTimeFields(data.value)}}</template>                    
                </b-table>
                <nav>
                    <b-pagination
                    :total-rows="result.rowCount"
                    :per-page.sync="result.pageSize"
                    v-model="currentPage"
                    prev-text="Voltar"
                    next-text="Próximo"
                    @change="pageIndexChanged"
                    first-text="Primeiro"
                    last-text="Último"
                    />
                </nav>
            </b-card-body>
        </b-card>
        <b-modal
          id="modal-upload"
          ref="modal"
          title="Importar arquivo de retorno"
          @hidden="resetUploadModal"
          @ok="handleUploadOk"
          ok-title="Fechar"
          :ok-only="true"
          v-model="uploadModalVisible">
          <div
            class="alert alert-danger"
            role="alert"
            v-show="uploadModel.hasError"
            >{{uploadModel.errorMessage}}</div>
          <form ref="form">            
            <div class="form-row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <file-upload :accept="'.ret,.txt'" :url='uploadModel.url' :headers="uploadModel.headers" btnLabel="Selecione um arquivo" btnUploadingLabel="Enviando arquivo..." @success="onFileUploadSuccess" @error="onFileUploadError" @change="onFileChange"></file-upload>
                    </div>
                </div>
            </div>
          </form>
        </b-modal>
    </div>
</template>
<script>
import editPage from '../../../mixins/editPage'
import domainService from '../../../services/MoneyFlow/moneyOutGroupService'
import moneyOutService from '../../../services/MoneyFlow/moneyOutService'
import moment from 'moment';
import { getDateMonthsBefore } from "../../../shared/utils";
import { getInstance } from '../../../auth/authWrapper'
import config from '../../../config'
import cTable from '../../../components/base/Table.vue'
export default {
    props: {
        id: String
    },
    mixins: [editPage],
    components: {
        cTable
    },
    data() {
        return {
            actionUri: '/partners/paymentgroups',
            model: {
                name: '',
                bankCode: '',
                fileName: '',
                createdAt: '',
                updatedAt: '',
                status: ''
            },
            fields: [
                { key: "scheduledDate", label: "Data Agendada", sortable: false },
                { key: "customerType", label: "Origem", sortable: false },
                { key: "customerDocument", label: "Doc.", sortable: false },
                { key: "customerName", label: "Empresa / Representante", sortable: false },
                { key: "status", label: "Status", sortable: false },
                { key: "userName", label: "Usuário", sortable: false },
                { key: "endedAt", label: "Data Pagto.", sortable: false },
                { key: "amount", label: "Valor", sortable: false },
                { key: "authorizationCode", label: "Cod. Aut.", sortable: false }
            ],
            currentPage: 1,
            result : this.getEmptyResult(),
            uploadModalVisible: false,
            uploadModel: {
                description: '',
                fileName: '',
                uriPath: '',
                errorMessage: '',
                hasError: false,
                url: `${config.apiEndpoints.moneyOutGroupUri}${this.id}/upload`,
                headers: {}
            },
            filesDataFields: [
                {key: 'name', label: 'Nome', sortable: false},
                {key: 'type', label: 'Tipo', sortable: false},
                {key: 'createdAt', label: 'Data Criação', sortable: false},
                {key: 'actions', label: ''}     
            ],
            filesData: this.getEmptyResult()
        }
    },
    computed: {
        canFinalizeMoneyOutGroup() {
            // if(this.model.files == null || this.model.files.length == 0) {
            //     return false;
            // }

            // let el = this.model.files.find(element => element.type == 'RETURN');

            // if(el == null)
            //  {
            //     return false;
            //  }

            return true;
        },
        status() {
            return this.model.status == '' ? '' : domainService.getStatus(this.model.status).name
        },
        createdAt() {
            return this.formatDateTimeFields(this.model.createdAt)
        },
        updatedAt() {
            return this.formatDateTimeFields(this.model.updatedAt)
        },
        amount() {
            return this.formatDecimalFields(this.model.amount)
        },
        customActions() {
            return [
                {
                    cssClass: 'btn mr-2 btn-md btn-primary action-btn btn-sm',
                    html: '<i class="fa fa-file"></i>',
                    action: 'getFileUrl'
                }
            ];
        },
        bankName() {
            switch(this.model.bankCode) {
                case '237':
                    return '237 - Banco Bradesco';
                case '341':
                    return '341 - Banco Itaú';
                default:
                    return this.model.bankCode;
            }
        }
    },
    async created(){
        this.fetchData()
        this.fetchItemsData(1)
        await this.setUploadModelToken();
    },
    methods: {
        async setUploadModelToken() {
            let authService = getInstance();
            let token = await authService.getTokenSilently();
            this.uploadModel.headers = {'Authorization': `Bearer ${token}`}
        },
        formatDateTimeFields(value) {
            return value == null || value == '' || value == '0001-01-01T00:00:00' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
        },
        formatDecimalFields(value) {
            return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
        bindBusinessTypeName(value) {
            switch(value.toUpperCase())
            {
                case 'SELLER':
                return 'Empresa';
                case 'SALESPERSON':
                return 'Representante';
                case 'Partner':
                    'Administrador';
            }
        },
        bindStatusName(value) {
            switch(value.toUpperCase()) {
                case 'CREATED':
                return 'Criado';
                case 'PROCESSING':
                return 'Processando';
                case 'CANCELED':
                return 'Cancelado';
                case 'PENDING':
                return 'Pendente';
                case 'ANALYSIS':
                return 'Em análise';
                case 'DONE':
                return 'Finalizado';
            }
        },
        fetchData() {
            const self = this
            self.showLoading()
            self.filesData = this.getEmptyResult();
            domainService.find(this.id).then((response) =>{
                self.model = response.data
                self.filesData.data = self.model.files;
                self.filesData.pageIndex = 0;
                self.filesData.pageCount = 1;
                self.filesData.pageSize = self.model.files.length;
                self.filesData.rowCount = self.model.files.length;
                self.hideLoading()
            }, () => {
                self.hideLoading()
            })
        },
        getEmptyResult() {
            return {
                pageIndex: 1,
                pageCount: 0,
                rowCount: 0,
                pageSize: 0,
                data:[]
            }
        },
        getSearchRequest() {
            return {
                sellerId: '',
                salesPersonId: '',
                bankCode: '',
                type: '',
                status: '',
                scheduledDate: '',
                endedDate: this.endedDate == null ? '' : this.endedDate,
                keywords: '',
                startDate: getDateMonthsBefore(new Date(), 1),
                endDate: new Date(),
                moneyOutGroupId: this.id
            }
        },
        pageIndexChanged(page) {
            this.currentPage = page;
            this.fetchItemsData(page);
        },
        fetchItemsData(page) {
            const self = this;
            self.showLoading();
            moneyOutService
            .findAll(
                this.getSearchRequest(),
                page
            )
            .then(
                (response) => {
                    if (response.status == 204) {
                        self.result = self.getEmptyResult();                        
                    } else {
                        self.result = response.data;                        
                    }
                    self.hideLoading();
                },
                (error) => {
                    self.hideLoading();
                }
            );
        },
        exportItemsData() {
            const self = this;
            self.showLoading();
            moneyOutService
            .findAllExport(
                this.getSearchRequest()
            )
            .then(
                (response) => {
                    window.open(response);
                    self.hideLoading();
                },
                (error) => {
                    self.hideLoading();
                }
            );
        },
        finalizeMoneyOutGroup() {
            this.updateStatus('DONE')
        },
        cancelMoneyOutGroup() {
            this.updateStatus('CANCELED')
        },
        updateStatus(status){
            const self = this
            self.showLoading()
            domainService.updateStatus({ id: this.id, status: status }).then((response) =>{
                self.hideLoading();
                self.fetchData();
                self.fetchItemsData(1);
            }, () => {
                self.hideLoading();
            })
        },
        uploadModal() {
            this.uploadModalVisible = true;
        },
        createNewFile() {
            const self = this
            self.showLoading()
            domainService.createSendFile({ id: this.id }).then((response) =>{
                self.hideLoading();
                self.fetchData();
                self.fetchItemsData(1);
            }, () => {
                self.hideLoading();
            })
        },
        onFileChange (file) {        
        },
        onFileUploadSuccess(evt) {
            const self = this;
            this.fetchData();
            this.fetchItemsData(1);
            this.$nextTick(() => {
                self.$refs.modal.hide()
            })
        },
        onFileUploadError(evt) {
            this.uploadModel.hasError = true;
            this.uploadModel.errorMessage = 'Ocorreu um erro no upload. Por favor, tente novamente';
        },
        resetUploadModal() {
            this.uploadModel.description = ''
            this.uploadModel.fileName = ''
            this.uploadModel.uriPath = ''
            this.uploadModel.hasError = false
            this.uploadModel.errorMessage = ''
        },
        handleUploadOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault()
            const self = this
            //todo: post
            self.$nextTick(() => {
                self.$refs.modal.hide()
            })
        },                
        onCustomActionClick(action, row) {
            window.open(row.item.name)
        }
    }
}
</script>